/**
 * @fileoverview Page module for navigation.
 */

import {
  validateNavigate,
  validateRedirect,
  logValidationErrors,
} from "../../core/validation";
import { PAGE_EVENTS } from "./events";
import type { PageModule, NavToOptions } from "./types";
import { postToHost } from "../../core/messenger";
import { createResizeFunctions } from "./functions/resize";
export type { PageModule, NavToOptions } from "./types";

/**
 * Create the page module.
 *
 * @returns Page module instance
 */
export function createPageModule(): PageModule {
  const { resize, autoResize, stopAutoResize } = createResizeFunctions();

  return {
    navigate(path: string, options?: NavToOptions): void {
      const validation = validateNavigate({ path, ...options });
      if (!validation.valid) {
        logValidationErrors(PAGE_EVENTS.NAVIGATE, validation.errors);
        return;
      }
      postToHost(PAGE_EVENTS.NAVIGATE, {
        path,
        state: options?.state,
        replace: options?.replace,
      });
    },

    redirect(url: string): void {
      const validation = validateRedirect({ url });
      if (!validation.valid) {
        logValidationErrors(PAGE_EVENTS.REDIRECT, validation.errors);
        return;
      }
      postToHost(PAGE_EVENTS.REDIRECT, { url });
    },

    navTo(path: string, options?: NavToOptions): void {
      if (path.startsWith("http://") || path.startsWith("https://")) {
        this.redirect(path);
        return;
      }
      this.navigate(path, options);
    },

    setTitle(title: string): void {
      if (typeof title !== "string" || !title.trim()) {
        logValidationErrors(PAGE_EVENTS.SET_TITLE, [
          "Title must be a non-empty string",
        ]);
        return;
      }
      postToHost(PAGE_EVENTS.SET_TITLE, { title });
    },

    resize,
    autoResize,
    stopAutoResize,
  };
}
